import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la alerta",
    opening: localizedGenderNode(
      [
      "Hoy no fuerzo la calma.",
      "Solo noto: hay alerta en mi."
    ],
      [
      "Hoy no fuerzo la calma.",
      "Solo noto: hay alerta en mi."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como se siente la alerta en mi cuerpo?",
      "Cuando es más fuerte?",
      "Que primer pensamiento aparece?"
    ],
      [
      "Como se siente la alerta en mi cuerpo?",
      "Cuando es más fuerte?",
      "Que primer pensamiento aparece?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La alerta es una experiencia, no una profecia."
    ],
      [
      "La alerta es una experiencia, no una profecia."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Hay alerta en mi, y estoy conmigo\".",
      "una respiracion + \"Hay alerta en mi, y estoy conmigo\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el primer momento en que sube la alerta.",
      "Solo noto."
    ],
      [
      "Hoy noto el primer momento en que sube la alerta.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "En que momento del día empieza?",
      "Que hace mi cuerpo primero?",
      "Que intento evitar?"
    ],
      [
      "En que momento del día empieza?",
      "Que hace mi cuerpo primero?",
      "Que intento evitar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando sube la alerta.",
      "una respiracion cuando sube la alerta."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Cuerpo antes que pensamiento",
    opening: localizedGenderNode(
      [
      "Hoy le doy espacio a mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy le doy espacio a mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se asienta la alerta en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde se asienta la alerta en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta protegerme."
    ],
      [
      "Mi cuerpo intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La historia del desastre",
    opening: localizedGenderNode(
      [
      "Hoy noto la historia que habla de desastre.",
      "No la peleo."
    ],
      [
      "Hoy noto la historia que habla de desastre.",
      "No la peleo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escenario aparece primero?",
      "Que es lo más aterrador en eso?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ],
      [
      "Que escenario aparece primero?",
      "Que es lo más aterrador en eso?",
      "Que posibilidad más suave tambien podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no es un hecho."
    ],
      [
      "Una historia no es un hecho."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Disparadores diarios",
    opening: localizedGenderNode(
      [
      "Hoy noto que enciende la alerta.",
      "Es conocimiento, no culpa."
    ],
      [
      "Hoy noto que enciende la alerta.",
      "Es conocimiento, no culpa."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el disparador que me enciende?",
      "Cuando vuelve?",
      "Que necesito ahi?"
    ],
      [
      "Cual es el disparador que me enciende?",
      "Cuando vuelve?",
      "Que necesito ahi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Nombrarlo ya es una calma pequeña."
    ],
      [
      "Nombrarlo ya es una calma pequeña."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de disparador.",
      "escribir una palabra de disparador."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Escanear peligro",
    opening: localizedGenderNode(
      [
      "Hoy noto el habito de escanear peligro.",
      "Solo noto."
    ],
      [
      "Hoy noto el habito de escanear peligro.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiracion."
    ],
      [
      "Siento mis pies.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde busco señales?",
      "Que creo que me protege si lo detecto a tiempo?",
      "Que me pasa despues de escanear?"
    ],
      [
      "Donde busco señales?",
      "Que creo que me protege si lo detecto a tiempo?",
      "Que me pasa despues de escanear?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "No tengo que escanear cada momento."
    ],
      [
      "No tengo que escanear cada momento."
    ]
    ),
    action: localizedGenderNode(
      "un momento sin comprobar.",
      "un momento sin comprobar."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La necesidad de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad de seguridad debajo de la alerta.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad de seguridad debajo de la alerta.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que intento conseguir con la alerta?",
      "Que sensación de seguridad me falta?",
      "Como se siente cuando hay un poco de seguridad?"
    ],
      [
      "Que intento conseguir con la alerta?",
      "Que sensación de seguridad me falta?",
      "Como se siente cuando hay un poco de seguridad?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Detras de la alerta hay una peticion."
    ],
      [
      "Detras de la alerta hay una peticion."
    ]
    ),
    action: localizedGenderNode(
      "escribir una peticion para mi.",
      "escribir una peticion para mi."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un limite interno",
    opening: localizedGenderNode(
      [
      "Hoy pongo un limite interno a la alerta.",
      "Sin pelear."
    ],
      [
      "Hoy pongo un limite interno a la alerta.",
      "Sin pelear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento los hombros aflojar un poco.",
      "Una respiracion."
    ],
      [
      "Siento los hombros aflojar un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que no me encaja en esta carga?",
      "Como me senala el cuerpo que es demasiado?",
      "Que frase interna puede frenarlo un poco?"
    ],
      [
      "Que no me encaja en esta carga?",
      "Como me senala el cuerpo que es demasiado?",
      "Que frase interna puede frenarlo un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un limite interno baja la intensidad."
    ],
      [
      "Un limite interno baja la intensidad."
    ]
    ),
    action: localizedGenderNode(
      "una frase silenciosa - \"Ahora es suficiente para mi\".",
      "una frase silenciosa - \"Ahora es suficiente para mi\"."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Miedo debajo",
    opening: localizedGenderNode(
      [
      "Hoy encuentro el miedo debajo de la alerta.",
      "Me quedo con el un momento."
    ],
      [
      "Hoy encuentro el miedo debajo de la alerta.",
      "Me quedo con el un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia el lugar sensible.",
      "Una respiracion."
    ],
      [
      "Respiro hacia el lugar sensible.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ],
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo quiere proteccion, no pelea."
    ],
      [
      "El miedo quiere proteccion, no pelea."
    ]
    ),
    action: localizedGenderNode(
      "nombrar el miedo en silencio.",
      "nombrar el miedo en silencio."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una pequeña confianza",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño punto de confianza.",
      "No uno grande."
    ],
      [
      "Hoy busco un pequeño punto de confianza.",
      "No uno grande."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ],
      [
      "Siento el aire entrar y salir.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando en el pasado se calmo la alerta?",
      "Que ayudo aunque sea un poco?",
      "En que pequeño puedo confiar hoy?"
    ],
      [
      "Cuando en el pasado se calmo la alerta?",
      "Que ayudo aunque sea un poco?",
      "En que pequeño puedo confiar hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña confianza basta para empezar."
    ],
      [
      "Una pequeña confianza basta para empezar."
    ]
    ),
    action: localizedGenderNode(
      "recordar una cosa que ayuda.",
      "recordar una cosa que ayuda."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Volver al cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a mi cuerpo cuando me pierdo.",
      "Estoy conmigo."
    ],
      [
      "Hoy vuelvo a mi cuerpo cuando me pierdo.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ],
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me devuelve a la presencia?",
      "Que respiracion me hace bien?",
      "Que siento ahora mismo?"
    ],
      [
      "Que me devuelve a la presencia?",
      "Que respiracion me hace bien?",
      "Que siento ahora mismo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La presencia baja el ruido."
    ],
      [
      "La presencia baja el ruido."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion lenta con una mano en el vientre.",
      "una respiracion lenta con una mano en el vientre."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un momento antes del impulso",
    opening: localizedGenderNode(
      [
      "Hoy doy un momento de calma antes del impulso de comprobar.",
      "Puedo esperar un momento."
    ],
      [
      "Hoy doy un momento de calma antes del impulso de comprobar.",
      "Puedo esperar un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto este momento.",
      "Una respiracion."
    ],
      [
      "Noto este momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es mi primer impulso cuando estoy en alerta?",
      "Que pasa si espero un momento?",
      "Que descubro despues de esperar?"
    ],
      [
      "Cual es mi primer impulso cuando estoy en alerta?",
      "Que pasa si espero un momento?",
      "Que descubro despues de esperar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento de calma es una eleccion."
    ],
      [
      "Un momento de calma es una eleccion."
    ]
    ),
    action: localizedGenderNode(
      "pausar antes de comprobar.",
      "pausar antes de comprobar."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño dentro de la alerta.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un paso pequeño dentro de la alerta.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ],
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso pequeño me calma?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ],
      [
      "Que paso pequeño me calma?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño basta."
    ],
      [
      "Lo pequeño basta."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño.",
      "elegir un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ],
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ],
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi de esta alerta?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ],
      [
      "Que aprendi de esta alerta?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo un momento antes de responder."
    ],
      [
      "Elijo un momento antes de responder."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + mi frase.",
      "una respiracion + mi frase."
    ),
  },
].map(buildNormalizedDay);

export const anxietyVigilanceBlueprintEs = buildNormalizedPilotBlueprint({
  id: "anxiety_vigilance_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "anxiety_vigilance",
  category: "anxiety",
  journeyName: {
    he: "תחושת דריכות תמידית / אסון עוד רגע מגיע",
    en: "Constant vigilance / a disaster is about to happen",
    es: "Sensación de alerta constante / algo malo por pasar",
  },
  days,
});

export default anxietyVigilanceBlueprintEs;
